import { Spinner } from "@hightouch/htui";

import { PreworkspacePage } from "src/components/layout/preworkspace-page";
import { AuthenticatedRoute } from "src/components/router/authenticated-route";
import { NoContextOutlet } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const FigmaPluginConnectPage = lazyNamed(
  () => import("./figma-plugin-connect"),
  "Page",
);

const FigmaPluginConnectLayout = () => {
  return (
    <PreworkspacePage title="Connect the Figma plugin">
      <NoContextOutlet />
    </PreworkspacePage>
  );
};

export const routes = {
  path: "figma-plugin/connect",
  element: <FigmaPluginConnectLayout />,
  children: [
    {
      index: true,
      element: (
        <AuthenticatedRoute loadingFallback={<Spinner size="lg" m="auto" />}>
          <FigmaPluginConnectPage />
        </AuthenticatedRoute>
      ),
    },
  ],
};
